// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProjectExternal } from 'src/app/model/project.external';
import { AppEnvironmentService } from '../app-environment.service';

const contentType = 'application/json';

@Injectable({ providedIn: 'root' })
export class TenantProjectService {

    constructor(private readonly http: HttpClient, private readonly appEnvironmentService: AppEnvironmentService) { }

    private get baseApiUrl(): string { return this.appEnvironmentService.baseApiUrl; }

    getTenantProjects(tenantId: number): Observable<ProjectExternal[]> {
        const accessToken = localStorage.getItem('access_token');
        const url = this.baseApiUrl + `tenants/${tenantId}/projects`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        return this.http.get<ProjectExternal[]>(url, { headers }).pipe(
            map(response => Array.isArray(response) ? response as ProjectExternal[] : [])
        );
    }

    createTenantProject(tenantId: number, projectCreationForm: any) {
        const accessToken = localStorage.getItem('access_token');
        const url = this.baseApiUrl + `tenants/${tenantId}/projects`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        return this.http.post(url, projectCreationForm, { headers });
    }

    updateProject(projectId: number, projectUpdateForm: any) {
        const accessToken = localStorage.getItem('access_token');
        const url = this.baseApiUrl + `projects/${projectId}`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        return this.http.put(url, projectUpdateForm, { headers });
    }
}
